import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
  ApolloProvider
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import React, { useContext } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URI
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = sessionStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  };
});

export const ERRORS = {
  '409': 'This user already exists'
};

export const getErrorMessage = (code: string): string => {
  for (const errorNum in ERRORS) {
    if (Object.prototype.hasOwnProperty.call(ERRORS, errorNum)) {
      if (code && code.includes(errorNum)) {
        return ERRORS[errorNum];
      }
    }
  }

  return 'Something went wrong';
};

export const ApolloCustomProvider = props => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, ...rest }) => {
        console.log(`[GraphQL error]: Message: ${message}`);
        console.log(
          `[${rest.extensions?.code || 'Details'}]: ${JSON.stringify(rest)}`
        );
        const errorMessage = getErrorMessage('' + message);

        enqueueSnackbar(t(errorMessage), {
          variant: 'error'
        });
      });

      if (networkError) console.log(`[Network error]: ${networkError}`);
    }
  });

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URI
  });

  const _client = new ApolloClient({
    link: from([authLink, errorLink, httpLink]),
    cache: new InMemoryCache()
  });

  return <ApolloProvider client={_client}>{props.children}</ApolloProvider>;
};
